export const URLEndPoint = "generator/Leads/CreateLead?subscription-key=";